import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertBmpToTiff() {
  return <ImageConverterTemplate sourceFormat="BMP" targetFormat="TIFF" acceptTypes=".bmp,image/bmp" slug="convert-bmp-to-tiff" gradientColors="from-purple-500 to-indigo-600" accentColor="purple" />;
}
